export function DashboardLoadingState() {
  return (
    <div data-testid="dashboard-loading-state" className="flex min-h-screen items-center justify-center bg-background">
      <div className="space-y-4 text-center">
        <div className="mx-auto h-12 w-12 animate-spin rounded-full border-2 border-white/20 border-t-white" />
        <p className="text-muted-foreground">Chargement...</p>
      </div>
    </div>
  );
}
